import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import { PreparingYourDataStep } from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/PreparingYourDataStep';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('preparing-data');
const prevPath = getPrevStepPath('preparing-data');

export const PreparingYourDataStepRoute: React.FC = () => {
  const navigate = useNavigate();

  useRegisterDataIntegrationStepControls({
    title: 'Preparing your data',
    subtitle:
      "We're syncing your connected channels. This may take a few moments.",
    currentStep: getStepIndex('preparing-data'),
    onNext: nextPath ? () => navigate(nextPath) : undefined,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: false,
    isNextDisabled: false,
  });

  return <PreparingYourDataStep />;
};
